var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tiptap-vuetify',{attrs:{"value":_vm.value,"card-props":{ disabled: true, flat: true },"extensions":_vm.extensions},scopedSlots:_vm._u([{key:"toolbar",fn:function({ }){return [_c('pre')]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }